import { Link } from 'react-router-dom';

import styled from 'styled-components';

const Container = styled.header`
  z-index: 10;
  position: relative;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 60px;
  background-color: white;
  box-shadow: 0px 2px 4px 0px rgba(120,120,120,0.1);
  padding: 0 16px 0 24px;
  display: flex;
	align-items: stretch;
	justify-content: space-between;

	@media (max-width: 1000px) {
		padding: 0 10px;
	}
`;

const Section = styled.div`
  display: flex;
`;

const UserAndLogo = styled.div`
  display: flex;
  justify-content: end;
	align-items: center;
`;

const Logo = styled.img`
  height: 30px;
  margin: 15px 0 15px 20px;
`;

const BackButton = styled(Link)`
  background-color: rgba(0,0,0,0);
  color: #787878;
  border: 0;
  height: 60px;
  padding-left: 24px;
  position: relative;
  cursor: pointer;
  font-size: 14px;
	justify-self: start;
	display: flex;
	align-items: center;

  &:before {
    content: "";
    position: absolute;
    top: calc(50% - 4px);
    left: 6px;
    width: 0px;
    height: 0px;
    border: 4px solid rgba(0,0,0,0);
    border-right-color: #787878;
  }
`;

const BuildingDetail = styled.p`
`;

const HideBelowWidth = styled.div`
	@media (max-width: ${props => props.width || '3000px'}) {
		display: none;
	}
`;

const HideBelowWidthInline = styled.span`
	@media (max-width: ${props => props.width || '3000px'}) {
		display: none;
	}
`;

const CollectionToggle = styled.div`
	color: ${props => props.open ? '#4A90E2' : '#787878'};
	position: relative;
	padding-right: 40px;
	padding-left: 10px;
	user-select: none;
	font-size: 14px;
	height: 100%;
	display: flex;
	align-items: center;
	cursor: pointer;

	@media (max-width: 1000px) {
		padding-right: 30px;
		padding-left: 0;
	}

	&:after {
		content: "";
    position: absolute;
    top: calc(50% - ${props => props.open ? '6px' : '2px'});
    right: 12px;
    width: 0px;
    height: 0px;
    border: 4px solid rgba(0,0,0,0);
    border-${props => props.open ? 'bottom' : 'top'}-color: ${props => props.open ? '#4A90E2' : '#787878'};
	}

	&:hover {
		color: #4A90E2;

		&:before {
			content: "";
			position: absolute;
			bottom: 0px;
			right: 0px;
			width: 100%;
			height: 2px;
			background-color: #4A90E2;
		}

		&:after {
			border: 4px solid rgba(0,0,0,0);
    	border-${props => props.open ? 'bottom' : 'top'}-color: #4A90E2;
		}
	}
`;


export {
	Container,
	Section,
	UserAndLogo,
	Logo,
	BackButton,
	BuildingDetail,
	HideBelowWidth,
	HideBelowWidthInline,
	CollectionToggle,
}
